import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useHomeBandsStore } from 'src/store/personalization/home-bands/home-bands.store';

const HEADER = [
  { id: 'text', label: 'Texto' },
  { id: 'startDate', label: 'Data de Início', type: 'date' },
  { id: 'endDate', label: 'Data de Fim', type: 'date' },
  { id: 'status', label: 'Stauts', type: 'label' },
];

export const useHomeBands = () => {
  const { isLoading, homeBands, findAll } = useHomeBandsStore();
  const navigate = useNavigate();

  useEffect(() => {
    findAll();
  }, []);

  return {
    isLoading,
    navigate,
    HEADER,
    homeBands,
  };
};
